import { createFileRoute } from "@tanstack/react-router"
import { BackofficeCapabilityExecutions } from "modules/backoffice/components/capabilityExecutions"
import { Crumb } from "modules/shared/lib/breadcrumbs"
import {
  BackofficeCapabilityExecutionActionEnum,
  BackofficeCapabilityExecutionProviderEnum,
  BackofficeCapabilityExecutionsDefaultCapabilities,
  CapabilityExecutionStatus,
  CapabilityReasonSchema,
  TimeFrameEnum,
  TimeFrameSchema,
} from "schema"
import { z } from "zod"

const SearchSchema = z.object({
  companyId: z.string().optional(),
  experiment: z.string().min(1).optional(),
  page: z.coerce.number().optional().default(1),
  total: z.coerce.number().optional().default(100),
  timeFrame: TimeFrameSchema.default(TimeFrameEnum.Last1Week),
  status: z.enum(["all", ...Object.values(CapabilityExecutionStatus)] as const).optional(),
  reason: z.union([z.literal("all"), CapabilityReasonSchema]).optional(),
  provider: z.enum(BackofficeCapabilityExecutionProviderEnum).optional(),
  capabilityIdentifier: z
    .string()
    .default(BackofficeCapabilityExecutionsDefaultCapabilities.join(",")),
  action: z.enum(BackofficeCapabilityExecutionActionEnum).optional(),
})

export const Route = createFileRoute("/_base/_auth/backoffice/capabilityExecutions")({
  component: BackofficeCapabilityExecutions,
  validateSearch: (search: Partial<z.infer<typeof SearchSchema>>) => SearchSchema.parse(search),
  loader: ({ route: { fullPath } }) =>
    new Crumb({
      fullPath,
      title: (t) => t("backoffice.capabilityExecutions.title"),
    }),
})
